import type { CustomInfoCategory } from '@/types';

/** Display names for the custom-info categories stored on `product_custom_info`. */
export const CATEGORY_LABELS: Record<CustomInfoCategory, string> = {
  sizing_fit: 'Sizing / Fit',
  materials: 'Materials',
  compatibility: 'Compatibility',
  usage: 'Usage',
  shipping_restrictions: 'Shipping Restrictions',
  policy_exception: 'Policy Exception',
  faq: 'FAQ',
  warranty: 'Warranty',
  promotions: 'Promotions',
  intended_audience: 'Intended Audience',
  discontinued: 'Discontinued',
  other: 'Other',
};

/** Selector order — mirrors CUSTOM_INFO_CATEGORIES in the backend model. */
export const CUSTOM_INFO_CATEGORIES: CustomInfoCategory[] = [
  'sizing_fit',
  'materials',
  'compatibility',
  'usage',
  'shipping_restrictions',
  'policy_exception',
  'faq',
  'warranty',
  'promotions',
  'intended_audience',
  'discontinued',
  'other',
];

/** The small pill button used across the product screens (Figma: 94x26, Border/Default). */
export const PILL_BUTTON =
  'h-[26px] cursor-pointer rounded-full border-gray-500 px-3 text-[13px] leading-[18px] font-normal text-foreground';
